/**
 * Created by bkila on 4/07/2017.
 */

export default {
  computed: {
    user: function user() {
      return this.$store.state.user.data;
    }
  },
  methods: {
    checkRoles: function checkRoles(roles, uroles) {
      var proceed = false;
      roles.forEach(function (obj) {
        if (uroles.indexOf(obj) !== -1) {
          proceed = true;
        }
      });
      return proceed;
    },
    hasRoles: function hasRoles(roles) {
      if (roles) {
        var uroles = [this.user.role];
        if (!uroles || uroles.length === 0) {
          return false;
        }
        return this.checkRoles(roles, uroles);
      }
      return false;
    },
    hasTeamAccess: function hasTeamAccess(teamId, role) {
      if (this.user.role === 'admin') {
        return true;
      }
      var has = false;
      if (role && teamId) {
        this.user.teams.forEach(function (obj) {
          if (obj.id === teamId && obj.role === role) {
            has = true;
          }
        });
      }
      return has;
    },
    hasMedicalProviderAccess: function hasMedicalProviderAccess(medicalProviderId, role) {
      if (this.user.role === 'admin') {
        return true;
      }
      var has = false;
      if (role && medicalProviderId) {
        this.user.medicalProviders.forEach(function (obj) {
          if (obj.id === medicalProviderId && obj.role === role) {
            has = true;
          }
        });
      }
      return has;
    },
    hasAssetAccess: function hasAssetAccess(assetId, role) {
      if (this.user.role === 'admin') {
        return true;
      }
      var has = false;
      if (role && assetId) {
        this.user.assets.forEach(function (obj) {
          if (obj.id === assetId && obj.role === role) {
            has = true;
          }
        });
      }
      return has;
    }
  }
};